import React from "react";
import { gql } from "@apollo/client";

import { Stack, Box } from "@mui/material";

export default function Billing({ order }) {
  return (
    <>
      {order.invoice && (
        <Stack spacing={1} direction="row" alignItems="center">
          <Box sx={{ flexGrow: 1 }}>Facture&nbsp;:</Box>
          <a
            href={order.invoice.file.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {order.invoice.reference}
          </a>
        </Stack>
      )}

      {order.invoice?.creditNotes.map((creditNote) => (
        <Stack
          key={creditNote.id}
          spacing={1}
          direction="row"
          alignItems="center"
        >
          <Box sx={{ flexGrow: 1 }}>Avoir&nbsp;:</Box>
          <a
            href={creditNote.file.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {creditNote.reference}
          </a>
        </Stack>
      ))}
    </>
  );
}

Billing.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_Billing_order on Order {
      id

      invoice {
        id
        reference
        file {
          id
          url
        }

        creditNotes {
          id
          reference
          file {
            id
            url
          }
        }
      }
    }
  `,
};
